import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/**
 * Performance Max on the Google search results page (mobile): the local
 * (place) ad, with a map thumbnail and call / directions / website chips.
 */
@Component({
  selector: 'app-pmax-google-search-mobile-04',
  imports: [CommonModule, MobileFrameComponent],
  templateUrl: './google-search-mobile-04.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './google-search-mobile-04.component.scss'
})
export class PmaxGoogleSearchMobile04PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton tab widths under the search box, in px. */
  readonly tabWidths = [16, 56, 60, 44, 16];

  /** Headline and description joined into one clamped line. */
  get summary(): string {
    const headline = this.data.headlines[0] || 'Your headline appears here';
    const description = this.data.descriptions[0] || 'Your description appears here.';
    return `${headline} - ${description}`;
  }
}
